module.exports = __webpack_public_path__ + "static/media/esg_campaign_sample_sheet.fc76af57.xlsx";